export default "__VITE_ASSET__BD$Q_V2c__"